import { gutter, GutterMarker } from "@codemirror/view";
import { controlCharsObject } from "../controlChars";

const pageMarker = new (class extends GutterMarker {
  toDOM() {
    return document.createTextNode("");
  }
  elementClass: string = "qp-active-line-gutter";

})();

const rowMarker = new (class extends GutterMarker {
  toDOM() {
    return document.createTextNode("");
  }
  elementClass: string = "qp-row-marker-gutter";

})();

const endGridMarker = new (class extends GutterMarker {
  toDOM() {
    return document.createTextNode("");
  }
  elementClass: string = "qp-end-grid-marker-gutter";

})();

const splitPageMarker = new (class extends GutterMarker {
  toDOM() {
    return document.createTextNode("");
  }
  elementClass: string = "qp-split-page-marker-gutter";

})();

// const emptyLineMarker = new (class extends GutterMarker {
//   toDOM() {
//     return document.createTextNode("x");
//   }
//   elementClass: string = "qp-active-line-gutter";

// })();

// const emptyModifierMarker = new (class extends GutterMarker {
//   toDOM() {
//     return document.createTextNode("x");
//   }
//   elementClass: string = "qp-active-line-gutter";

// })();

export const currentLineGutter = gutter({

  lineMarker(view, { from }) {
    const currentLine = view.state.doc.lineAt(view.state.selection.main.from);
    const currentLineNumber = currentLine.number;
    const lineNumber = view.state.doc.lineAt(from).number;
    if (view.state.doc.lineAt(from).text.trim() === controlCharsObject["---"].controlChar) return rowMarker
    if (view.state.doc.lineAt(from).text.trim() === controlCharsObject["-->"].controlChar) return endGridMarker

    if (view.state.doc.lineAt(from).text.trim() === controlCharsObject["|"].controlChar) return splitPageMarker

    return lineNumber == currentLineNumber ? pageMarker : null;
  },
  renderEmptyElements: true,

  initialSpacer: () => pageMarker,
});


